/* TODO: t() */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { Component } from 'react';
import { StyleSheet } from 'react-native';

import { showError, showSuccess } from '../App/AppAlert';
import connectData, { ConnectedProps } from '../../support/connectData';
import AccountActions from '../../support/AccountActions';
import { postJSON } from '../../support/Fetch';
import ensureObject from '../../support/shared/ensureObject';
import { canUser } from '../../support/shared/permissionHelpers';

import LoadingIndicator from '../uiold/LoadingIndicator';
import { Button, ButtonToolbar, Card, Page, Text, TextInput } from '../uiold';

import { Account } from '../../types/shared/Account';

type State = {
  embedStyle: string;
  isSaving: boolean;
};

class CustomStyleSettings extends Component<FullProps, State> {
  state: State = {
    embedStyle: getEmbedStyle(this.props.account),
    isSaving: false,
  };

  render() {
    let { user } = this.props;
    let canEdit = user && canUser(user, { settings: 'WRITE' });
    return (
      <Page>
        <Page.Header title="Embed Styling">
          {this._renderSaveControls()}
        </Page.Header>
        <Card>
          <Text style={styles.description}>
            {`Custom styling for "embed code" features (e.g. Signup Form). `}
          </Text>
          <TextInput
            style={styles.codeArea}
            disabled={!canEdit}
            multiline={true}
            numberOfLines={12}
            value={this.state.embedStyle}
            onChangeText={this._onEditorValueChange}
          />
        </Card>
      </Page>
    );
  }

  _onEditorValueChange = (value: string) => {
    this.setState({ embedStyle: value });
  };

  _renderSaveControls = () => {
    let { account } = this.props;
    let { embedStyle, isSaving } = this.state;
    if (getEmbedStyle(account) === embedStyle) {
      return null;
    }
    return isSaving ? (
      <LoadingIndicator />
    ) : (
      <ButtonToolbar>
        <Button title="Revert" onPress={this._onReset} />
        <Button title="Save" onPress={this._onSave} isPrimary />
      </ButtonToolbar>
    );
  };

  _onSave = () => {
    let { account } = this.props;
    let { embedStyle } = this.state;

    if (account) {
      let accountID = account.id;
      let updates = { embed_style: embedStyle };
      let postData = { account: { settings: updates } };
      postJSON(
        `/api/accounts/${accountID}/settings`,
        postData,
        (error, data) => {
          if (error) {
            console.error(error); // eslint-disable-line no-console
            let errorObject = ensureObject(error);
            let errorMessage = errorObject
              ? String(errorObject.message)
              : String(error);
            showError(`Unable to complete request: ${errorMessage}`);
            return;
          }
          if (data.success) {
            AccountActions.updateSettings(updates);
            showSuccess(`Saved Successfully.`);
          }
          this.setState({ isSaving: false });
        },
      );
      this.setState({ isSaving: true });
    }
  };

  _onReset = () => {
    this.setState({
      isSaving: false,
      embedStyle: getEmbedStyle(this.props.account),
    });
  };
}

let styles = StyleSheet.create({
  description: {
    marginBottom: 10,
  },
  codeArea: {
    fontFamily: 'Menlo, Monaco, Consolas, "Courier New", monospace',
    whiteSpace: 'pre',
  },
});

function getEmbedStyle(account: Account | null | undefined) {
  return account && account.settings && account.settings.embed_style
    ? account.settings.embed_style
    : '';
}

const connector = connectData()(() => ({
  account: { dataStoreKey: 'account' },
  user: { dataStoreKey: 'user' },
}));
type FullProps = ConnectedProps<typeof connector>;
export default connector(CustomStyleSettings);
